






































import { NewCompanyParams } from '@/store/interfaces/company';
import company from '@/store/types/company';
import Vue, { PropType } from 'vue';

interface tModel {
  name: string;
  email: string;
  phone: string;
  contact_kind_id: string;
}

export default Vue.extend({
  name: 'ContactsForms',
  props: {
    contact: {
      type: String,
      required: true,
    },
    contactKindId: {
      type: String,
      required: true,
    },
    saveOnVuexKey: {
      type: Number,
      required: true,
    },
    companyInfo: {
      type: Object as PropType<NewCompanyParams>,
      required: true,
    },
  },
  components: {},
  data() {
    return {
      model: {
        name: '',
        email: '',
        phone: '',
        contact_kind_id: '',
      } as tModel,
    };
  },
  mounted() {
    this.model = this.companyInfo.contacts[this.saveOnVuexKey];
    this.model.contact_kind_id = this.contactKindId;
  },

  watch: {
    model: {
      immediate: true,
      deep: true,
      handler(model: tModel) {
        setTimeout(() => {
          const data = {
            position: this.saveOnVuexKey,
            contact: model,
          };
          this.$store.commit(
            `companyModule/${company.mutations.SET_CONTACT}`,
            data
          );
        }, 500);
      },
    },
  },
});
